
export default function AboutSection() {
  return (
    <section id="about" className="py-20 bg-gradient-to-br from-gray-50 via-amber-50/30 to-gray-50">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
            About <span className="text-transparent bg-clip-text bg-gradient-to-r from-amber-600 via-yellow-500 to-amber-700">Us</span>
          </h2>
          <div className="w-24 h-1 bg-gradient-to-r from-amber-500 via-yellow-400 to-amber-600 mx-auto mb-8 shadow-sm"></div>
        </div>

        <div className="grid lg:grid-cols-2 gap-12 items-center mb-20">
          <div className="relative">
            <div className="absolute inset-0 bg-gradient-to-r from-amber-100/20 to-yellow-100/20 rounded-2xl transform rotate-1"></div>
            <div className="relative bg-white/80 backdrop-blur-sm p-8 rounded-2xl shadow-lg border border-amber-100/50">
              <p className="text-lg text-gray-700 leading-relaxed mb-6">
                <span className="text-amber-700 font-semibold">Castle & Castle Marketing Agency</span> is a full-stack growth marketing agency specializing in iterative, data-driven growth operations for fast-growing companies.
              </p>
              <p className="text-lg text-gray-700 leading-relaxed mb-6">
                We provide access to <span className="text-amber-600 font-medium">top experts</span> across multiple channels including online communities, SEO, public relations, influencer marketing, and paid ads.
              </p>
              <p className="text-lg text-gray-700 leading-relaxed">
                As a hassle-free and efficient alternative to managing in-house marketers or freelancers, we are your <span className="text-transparent bg-clip-text bg-gradient-to-r from-amber-600 to-yellow-600 font-semibold">growth team on demand</span>.
              </p>
            </div>
          </div>
          <div className="relative">
            <div className="absolute inset-0 bg-gradient-to-br from-amber-200/30 to-yellow-200/30 rounded-lg transform -rotate-1"></div>
            <img 
              src="https://public.readdy.ai/ai/img_res/c737f7412bc9bf0897d0df48a35bc36a.jpg" 
              alt="Castle & Castle Team" 
              className="relative rounded-lg shadow-xl object-cover w-full h-80 border-2 border-amber-100/50"
            />
          </div>
        </div>

        <div>
          <h3 className="text-3xl font-bold text-center text-gray-900 mb-4">
            Leadership <span className="text-transparent bg-clip-text bg-gradient-to-r from-amber-600 via-yellow-500 to-amber-700">Team</span>
          </h3>
          <div className="w-16 h-0.5 bg-gradient-to-r from-amber-500 to-yellow-500 mx-auto mb-12"></div>
          
          <div className="grid md:grid-cols-2 gap-8">
            <div className="bg-gradient-to-br from-white via-amber-50/30 to-white rounded-xl shadow-lg p-8 text-center hover:shadow-xl transition-all duration-300 border border-amber-100/30 hover:border-amber-200/50">
              <div className="relative mb-6">
                <div className="absolute inset-0 bg-gradient-to-br from-amber-200/40 to-yellow-200/40 rounded-full transform scale-110"></div>
                <img 
                  src="https://static.readdy.ai/image/c02e1238a9e0afa048eae5bb36a2fc1c/4a655a94ddc8bac4c5d6ffa5fecdd792.png" 
                  alt="Sani Bula" 
                  className="relative w-32 h-32 rounded-full mx-auto object-cover object-top shadow-lg border-3 border-amber-200/50"
                />
              </div>
              <h4 className="text-xl font-bold text-gray-900 mb-2">Sani Bula</h4>
              <p className="text-transparent bg-clip-text bg-gradient-to-r from-amber-600 to-yellow-600 font-bold mb-3 uppercase tracking-wide text-sm">Founder</p>
              <p className="text-gray-600">Visionary Strategist</p>
            </div>

            <div className="bg-gradient-to-br from-white via-amber-50/30 to-white rounded-xl shadow-lg p-8 text-center hover:shadow-xl transition-all duration-300 border border-amber-100/30 hover:border-amber-200/50">
              <div className="relative mb-6">
                <div className="absolute inset-0 bg-gradient-to-br from-amber-200/40 to-yellow-200/40 rounded-full transform scale-110"></div>
                <img 
                  src="https://static.readdy.ai/image/c02e1238a9e0afa048eae5bb36a2fc1c/22abde3c11aa3187aefea135c09c2eb1.png" 
                  alt="Sarah Annabels" 
                  className="relative w-32 h-32 rounded-full mx-auto object-cover object-top shadow-lg border-3 border-amber-200/50"
                />
              </div>
              <h4 className="text-xl font-bold text-gray-900 mb-2">Sarah Annabels</h4>
              <p className="text-transparent bg-clip-text bg-gradient-to-r from-amber-600 to-yellow-600 font-bold mb-3 uppercase tracking-wide text-sm">Co-Founder</p>
              <p className="text-gray-600">Expert in client success & campaigns</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}